import AboutSectionA from "./Sections/AboutSectionA"
import AboutSectionB from "./Sections/AboutSectionB"

const About = () => (
    <>
    <AboutSectionA/>
    <AboutSectionB/>
    </>
)

export default About